import React, { useEffect, useState } from "react";
import AboutReviewSlider from "../../components/AboutReviewSlider";
import { getAllReviews } from "../../api/fetch";

const AboutUs = () => {
  const [activeStep, setActiveStep] = React.useState(0);
  const [reviews, SetReviews] = useState([]);

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  const steps = [
    {
      title: "Book in Just 2 Tabs",
      description:
        "Curabitur ac quam aliquam urna vehicula semper sed vel elit. Sed et leo purus. Vivamus vitae sapien.",
      icon: "./assets/1.webp",
    },
    {
      title: "Get a Driver",
      description:
        "Curabitur ac quam aliquam urna vehicula semper sed vel elit. Sed et leo purus. Vivamus vitae sapien.",
      icon: "./assets/2.webp",
    },
    {
      title: "Track your Driver",
      description:
        "Curabitur ac quam aliquam urna vehicula semper sed vel elit. Sed et leo purus. Vivamus vitae sapien.",
      icon: "./assets/3.webp",
    },
    {
      title: "Arrive safely",
      description:
        "Curabitur ac quam aliquam urna vehicula semper sed vel elit. Sed et leo purus. Vivamus vitae sapien.",
      icon: "./assets/4.webp",
    },
  ];

  useEffect(() => {
    fetchReviews();
  }, []);

  const fetchReviews = async () => {
    try {
      const res = await getAllReviews();
      console.log("RESS ::", res);
      if (res?.status) {
        SetReviews(res?.data);
      }
    } catch (error) {
      console.log("Eroro ::", error);
    }
  };

  return (
    <>
      <div className="bg-white text-gray-800 font-Poppins">
        <div className="mx-auto text-center flex flex-col">
          <div className="w-full self-center flex flex-col items-center justify-center bg-[#fffbee] lg:py-10 md:py-10 py-3">
            <h1 className="text-2xl lg:text-4xl font-semibold">About Us</h1>
            <img
              src="./assets/border.webp"
              className=" lg:my-6 md:my-4 my-2"
              alt="Header Decoration"
            />
          </div>

          <div className="flex flex-col md:flex-row items-center justify-between md:space-y-0 md:space-x-8">
            <div className="w-full md:w-[80%] px-5">
              <p className="text-xl text-gray-600 lg:mb-10 md:mb-8 my-2">
                <span className="lg:text-7xl md:text-5xl text-3xl font-bold">
                  Welcome to{" "}
                  <span className="font-bold text-black">Taxica</span>
                  <span className="font-bold text-yellow-500"> India</span>,
                </span>
                <br />
                your trusted partner for all your taxi service needs. We are
                committed to providing safe, reliable, and efficient
                transportation services to customers across the country.
              </p>
            </div>
            <div className="w-full h-full ">
              <img
                src="./assets/about.jpg"
                alt="Header Decoration"
                className="w-[100%] h-[80%] object-cover"
              />
            </div>
          </div>

          <div
            className="relative bg-cover bg-center bg-no-repeat h-[400px] flex items-center justify-center lg:mt-8 md:mt-6 mt-1"
            style={{
              backgroundImage: `url('https://carrgohtml.tortoizthemes.com/assets/images/counter-bg.webp')`,
            }}
          >
            <div className="absolute inset-0 bg-black bg-opacity-60"></div>{" "}
            {/* Dark overlay */}
            <div className="relative z-10 w-full px-4 sm:px-6 lg:px-12 grid grid-cols-2 sm:grid-cols-4 gap-6 text-white">
              <div className="flex flex-col items-center space-y-2">
                <img
                  src="./assets/counter-icon-1.webp"
                  className="w-10 h-10"
                  alt="Step Icon"
                />
                <h3 className="lg:text-3xl md:text-2xl text-xl font-bold">
                  750,000
                </h3>
                <p className="lg:text-2xl md:text-xl text-lg">Vehicles</p>
              </div>

              <div className="flex flex-col items-center space-y-2">
                <img
                  src="./assets/counter-icon-2.webp"
                  className="w-10 h-10"
                  alt="Step Icon"
                />
                <h3 className="lg:text-3xl md:text-2xl text-xl font-bold">
                  220 +
                </h3>
                <p className="lg:text-2xl md:text-xl text-lg">Cities</p>
              </div>

              <div className="flex flex-col items-center space-y-2">
                <img
                  src="./assets/counter-icon-3.webp"
                  className="w-10 h-10"
                  alt="Step Icon"
                />
                <h3 className="lg:text-3xl md:text-2xl text-xl font-bold">
                  550,000
                </h3>
                <p className="lg:text-2xl md:text-xl text-lg">
                  Entrepreneurs Partners
                </p>
              </div>

              <div className="flex flex-col items-center space-y-2">
                <img
                  src="./assets/counter-icon4.webp"
                  className="w-10 h-10"
                  alt="Step Icon"
                />
                <h3 className="lg:text-3xl md:text-2xl text-xl font-bold">
                  7,500,000
                </h3>
                <p className="lg:text-2xl md:text-xl text-lg">Passengers</p>
              </div>
            </div>
          </div>

          <div className="lg:py-14 md:py-10 py-6 flex flex-col space-y-8 bg-white">
            <div className="flex flex-col items-center justify-center">
              <h2 className="text-3xl font-bold text-center">How It Works</h2>
              <img
                src="./assets/border.webp"
                className="my-5"
                alt="Header Decoration"
              />
            </div>
            <div className="flex justify-center">
              <div className="w-full max-w-screen-xl">
                <div className="flex flex-col justify-around md:flex-row space-y-8 md:space-y-0 md:space-x-8">
                  {steps?.map((step, index) => (
                    <div className="flex items-center flex-col justify-center space-x-4 space-y-4">
                      <div
                        className={`w-24 h-24 p-4 rounded-full flex items-center justify-center bg-[#f1f1f1]`}
                      >
                        <img
                          src={step?.icon}
                          className="max-w-full max-h-full"
                          alt="Step Icon"
                        />
                      </div>
                      <h3 className="text-2xl font-semibold mb-2">
                        {step.title}
                      </h3>
                      {/* <p className="text-gray-600">{step.description}</p> */}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {reviews && <AboutReviewSlider data={reviews} />}
        </div>
      </div>
    </>
  );
};

export default AboutUs;
